var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("el-form", { ref: "ruleForm", attrs: { model: _vm.clearVoucher } }, [
        _c("div", { staticClass: "simple-form flex col-2" }, [
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("清除单号")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _vm.clearVoucher.srcVoucherType != null
                  ? _c("el-tag", { attrs: { type: "danger" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.voucherTypeMap[_vm.clearVoucher.srcVoucherType]
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.clearVoucher.no))])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.clearVoucher.srcVoucherType != null
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("来源单据号：")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.clearVoucher.srcVoucherNo))])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("所属业务单元")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.clearVoucher.bizUnitName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("清除时间")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.clearVoucher.theDate))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("仓库")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.clearVoucher.warehouseName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("创建人")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.clearVoucher.creatorName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("创建业务单元")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.clearVoucher.creatorBizUnitName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("创建时间")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.clearVoucher.createTime))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-caption dashed" }, [
          _c("span", [
            _c("span", { staticClass: "color-laber" }),
            _vm._v(
              _vm._s(_vm.clearVoucher.assetType != 2 ? "资产信息" : "耗材信息")
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-layout" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.shopDeviceClearItems,
                  border: "",
                  "tooltip-effect": "dark"
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "title",
                    label: "资产描述全称",
                    width: "170",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "name",
                    label: "名称",
                    width: "170",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "model",
                    label: "型号",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "fixedSpec",
                    label: "规格",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { label: "资产基础信息", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "tmpNo",
                        "min-width": "250",
                        label: "系统编号",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "innerNo",
                        "min-width": "250",
                        label: "外部系统编号",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "vendorUkno",
                        "min-width": "250",
                        label: "商品标识码",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "catName",
                        width: "100",
                        label: "分类",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "groupName",
                        label: "分类分组",
                        width: "120",
                        align: "left",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getGoodsCatDevcGroupName(rows.row.catId)
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "brandName",
                        width: "150",
                        label: "品牌",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "left", width: "50", label: "图片" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.imageUrl != null &&
                              rows.row.imageUrl != ""
                                ? _c("img", {
                                    attrs: { src: rows.row.imageUrl }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "assetKindName",
                        label: "财务类别",
                        width: "150",
                        align: "left",
                        "show-overflow-tooltip": ""
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { label: "清除信息", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "clearCause",
                        align: "left",
                        label: "原因",
                        width: "60"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.devcClearCauseMap[rows.row.clearCause]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "departName",
                        "min-width": "150",
                        label: "清除部门"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "quantity",
                        "min-width": "100",
                        label: "清除数量"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "staffName",
                        "min-width": "100",
                        label: "清除人员"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "memo",
                        label: "备注",
                        "show-overflow-tooltip": ""
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { label: "附加信息", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "batchNo",
                        "min-width": "180",
                        label: "批次号",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "innerCode",
                        "min-width": "180",
                        label: "资产编号",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "theUnit",
                        "min-width": "50",
                        label: "单位"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { label: "资产价值", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        "min-width": "100",
                        label: "入账方式"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.acctEnterWayMap[rows.row.acctEnterWay]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "100",
                        label: "是否财务在账"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    rows.row.fiscalAcctFlag == 1 ? "是" : "否"
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "orgWorth",
                        "min-width": "80",
                        label: "原值(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.orgWorth != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.orgWorth.toFixed(2)))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "netWorth",
                        "min-width": "80",
                        label: "净值(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.netWorth != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.netWorth.toFixed(2)))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "assetType",
                        "min-width": "80",
                        label: "管理方式"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    rows.row.assetType == 0
                                      ? "单品式管理"
                                      : "批量式管理"
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-layout" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "page-size": _vm.pageSize,
                "page-sizes": _vm.pageSizes,
                "current-page": _vm.pageNumber,
                total: _vm.totalCount,
                layout: "prev, pager, next, jumper, sizes, total"
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("清除信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f3d87d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f3d87d3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/clearVoucher/ShopDeviceClearVoucherShow.vue
// module id = 2593
// module chunks = 0